import React, { forwardRef } from 'react';
import styled from 'styled-components';

import useHover from 'shared/hooks/use-hover';

import { DragImage } from 'src/dispensary-admin/customize/homepage/sections/components/drag-image';
import { RemoveButton } from 'src/dispensary-admin/customize/homepage/sections/components/remove-button';

type ListItemProps = {
  className?: string;
  primaryText: string;
  secondaryText: string;
  isDragging?: boolean;
  onRemove?: () => void;
  style?: React.CSSProperties;
};

export const ListItem = forwardRef<HTMLDivElement, ListItemProps>((props: ListItemProps, ref) => {
  const { className, primaryText = '', secondaryText = '', isDragging = false, onRemove, style } = props;
  const [hoverRef, isHovered] = useHover();

  return (
    <DraggableOptionStyles ref={ref} className={className} isDragging={isDragging} style={style}>
      <HoverContainer ref={hoverRef}>
        <TextContainer>
          <PrimaryText>{primaryText}</PrimaryText>
          <SecondaryText>{secondaryText}</SecondaryText>
        </TextContainer>
        <RemoveButton visible={isHovered && !isDragging} onClick={onRemove} />
        <DragImage disabled={false} />
      </HoverContainer>
    </DraggableOptionStyles>
  );
});

const DraggableOptionStyles = styled.div<{ isDragging: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 64px;
  padding: 16px 18px 16px 18px;
  opacity: ${({ isDragging }) => (isDragging ? 0 : 1)};
`;

const HoverContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  width: 100%;
`;

const TextContainer = styled.div`
  flex: 1 1 auto;
  margin-right: 12px;
`;

const PrimaryText = styled.span`
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: bold;
  line-height: 15px;
  color: ${({ theme }) => theme.colors.v2TextColor2};
`;

const SecondaryText = styled.span`
  display: block;
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.v2TextColor1};
`;
